import { useState } from "react"
import AwardInterface from "../../../interfaces/Award.interface"
import Modal from "../../../components/Modal"
import InputText from "../../../components/InputText"
import TextArea from "../../../components/TextArea"
import Button from "../../../components/Button"
import { updateAwardService } from "../../../services/awards.services"
import { useAppSelector } from "../../../store/store"
import { toast } from "react-toastify"

const EditForm: React.FC<{ award: AwardInterface, onUpdated?: (award: AwardInterface) => void }> = ({ award, onUpdated = () => { } }) => {
    const token = useAppSelector(state => state.token)

    const [requesting, setRequesting] = useState<boolean>(false)
    const [data, setData] = useState({
        name: award.name as string,
        code: award.code as string,
        description: award.description as string,
    })
    const [editModal, setEditModal] = useState<boolean>(false)

    const handleChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (event) => setData({ ...data, [event.target.name]: event.target.value })

    const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
        event.preventDefault()
        updateAwardService({ ...data, awardId: award?.id as string, token: token || "" })
            .then((res) => {
                toast.success(res.data.message)
                onUpdated(res.data.payload.award)
            })
            .catch((error) => toast.error(error.response.data.message))
            .finally(() => setRequesting(false))
    }

    return (
        <>
            <button className="self-start text-zinc-500" onClick={() => setEditModal(!editModal)}>Editar</button>
            <Modal modalOpen={editModal} set={setEditModal}>
                <div className="w-[420px] flex flex-col gap-5 bg-white p-5 rounded">
                    <p className="text-zinc-500 text-xl">Editar premio</p>
                    <div className="h-[100px] w-[100px] min-h-[100px] min-w-[100px] flex items-center justify-center rounded bg-gray-200 text-3xl self-center">?</div>
                    <form className="flex flex-col gap-5" onSubmit={handleSubmit}>
                        <InputText
                            type="text"
                            name="name"
                            placeholder="Nombre"
                            onChange={handleChange}
                            value={data.name}
                        />
                        <InputText
                            type="text"
                            name="code"
                            placeholder="Código"
                            onChange={handleChange}
                            value={data.code}
                        />
                        <TextArea
                            name="description"
                            onChange={handleChange}
                            rows={6}
                            placeholder="Descripción"
                            value={data.description}
                        ></TextArea>
                        <Button spinner={requesting} disabled={requesting}>Actualizar</Button>
                    </form>
                </div>
            </Modal>
        </>
    )
}

export default EditForm